import { pick } from 'lodash';
import * as api from 'helpers/api';

const rootPath = '/contacts/tasks';

const transformTaskData = (taskData) => {
  const task = pick(taskData, [
    'id',
    'assigneeId',
    'body',
    'completed',
    'dueDate',
    'logged',
    'pinned',
    'reminderDifference',
    'taskType',
    'title'
  ]);

  task.taskAssociationsAttributes = taskData.associatedModels;
  task.taskListItemsAttributes = taskData.taskListItems;
  task.taskTaggedRecordsAttributes = taskData.taskTaggedRecords;

  return task;
};

export const addTask = (task, flushIndex = false) => {
  return api.post(rootPath, { flushIndex, contactsTask: transformTaskData(task) });
};

export const bulkCreate = (task, contacts, projectId) => {
  return api.post(`${rootPath}/bulk_create`, { contactsTask: transformTaskData(task), contacts, projectId });
};

export const createCallList = (callList, task, contacts, projectId) => {
  return api.post(`${rootPath}/bulk_create`, { contactsTask: transformTaskData(task), contacts, callList, projectId });
};

export const removeTask = (task) => {
  return api.deleteRequest(`${rootPath}/${task.id}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
};

export const updateTask = (task, flushIndex = false) => {
  const { id, ...taskFields } = transformTaskData(task);
  return api.patch(`${rootPath}/${id}`, { flushIndex, contactsTask: taskFields });
};

export const fetchTaskAttachments = (id) => {
  return api.get(`${rootPath}/${id}/attachments`).then(({ attachments }) => attachments || []);
};

export default {
  addTask,
  bulkCreate,
  createCallList,
  fetchTaskAttachments,
  removeTask,
  updateTask
};
